import { render, staticRenderFns } from "./BookshelfDisplay.vue?vue&type=template&id=51c3de63&scoped=true&"
import script from "./BookshelfDisplay.vue?vue&type=script&lang=ts&"
export * from "./BookshelfDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c3de63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem})
